import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {


  protected env = 'pro';

  public cmsServerURL: string;
  public waApiServerURL: string;

  public constructor() {

    switch (this.env) {
      case 'pro':
        this.cmsServerURL = 'https://worldarchery.sport';
        break;

      case 'stg':
        this.cmsServerURL = 'https://tests.worldarchery.sport';
        break;

      case 'dev':
        this.cmsServerURL = 'http://worldarchery.me';
    }

    // API server it's always the same.
    this.waApiServerURL = 'https://api.worldarchery.sport';
  }

  public getWAServerURL() {
    return this.cmsServerURL;
  }

  public isDev(): boolean {
    return this.env === 'dev';
  }

  public getEnv(): string {
    return this.env;
  }
}
